import BaseSportPage from '../components/shared/BaseSportPage';
export default function Handball() {
  return <BaseSportPage sport="handball" label="Handball" />;
}
